<template>
  <div class="module-list">
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Reviewing Inventory and Listing Items" partName="Listing Items for Sale">
          <div class="item-title">Inventory Display</div>
          <div class="item-summary">
            The inventory shows all items available for listing. Players can filter items based on categories such as
            <strong>Characters, Firearms, Melee Weapons, Gloves, Stickers, and Weapon Cases.</strong>
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/sale1.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Reviewing Inventory and Listing Items" partName="Listing Items for Sale">
          <div class="item-title">Currency Options</div>
          <div class="item-summary">
            Players can select the currency type for the listing, including <strong>$Fire</strong> or
            <strong>Diamonds</strong>. When a listed item is
            successfully sold, the system will notify the player via an in-game email.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/sale2.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Managing Listed Items" partName="Listing Items for Sale">
          <div class="item-summary">
            <strong>The Listed Items Management section displays all items currently listed by the player. From this
              interface, players can:</strong>
          </div>
          <div class="item-summary">
            <strong>Cancel Listings:</strong> Remove an item from the market.
          </div>
          <div class="item-summary">
            <strong>Modify Prices:</strong> Adjust the price of a listed item.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/sale3.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleWrap from "../titleWrap";
export default {
  components: { TitleWrap },
  props: {},
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>